import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

const http = axios.create({ baseURL: API });

export const api = {
  getTiers: () => http.get("/pricing/tiers").then((r) => r.data),
  estimate: (payload) => http.post("/pricing/estimate", payload).then((r) => r.data),
  subscription: (payload) => http.post("/requests/subscription", payload).then((r) => r.data),
  appointment: (payload) => http.post("/requests/appointment", payload).then((r) => r.data),
  partner: (payload) => http.post("/requests/partner", payload).then((r) => r.data),
  contact: (payload) => http.post("/requests/contact", payload).then((r) => r.data),
  estimateLead: (payload) => http.post("/requests/estimate-lead", payload).then((r) => r.data),
  visit: (payload) => http.post("/requests/visit", payload).then((r) => r.data),
  notify: (payload) => http.post("/requests/notify", payload).then((r) => r.data),
  track: (payload) => http.post("/track", payload).then((r) => r.data),
  publicStats: () => http.get("/stats/public").then((r) => r.data),
  // CMS public
  getContent: () => http.get("/content").then((r) => r.data),
  articles: () => http.get("/articles").then((r) => r.data),
  article: (slug) => http.get(`/articles/${slug}`).then((r) => r.data),
  pages: () => http.get("/pages").then((r) => r.data),
  page: (slug) => http.get(`/pages/${slug}`).then((r) => r.data),
  // CMS admin
  adminPutContent: (passcode, payload) =>
    http.put("/admin/content", payload, { headers: { "X-Admin-Passcode": passcode } }).then((r) => r.data),
  adminPutPricing: (passcode, payload) =>
    http.put("/admin/pricing", payload, { headers: { "X-Admin-Passcode": passcode } }).then((r) => r.data),
  adminArticles: (p) => http.get("/admin/articles", { headers: { "X-Admin-Passcode": p } }).then((r) => r.data),
  adminCreateArticle: (p, payload) =>
    http.post("/admin/articles", payload, { headers: { "X-Admin-Passcode": p } }).then((r) => r.data),
  adminUpdateArticle: (p, id, payload) =>
    http.put(`/admin/articles/${id}`, payload, { headers: { "X-Admin-Passcode": p } }).then((r) => r.data),
  adminDeleteArticle: (p, id) =>
    http.delete(`/admin/articles/${id}`, { headers: { "X-Admin-Passcode": p } }).then((r) => r.data),
  adminPages: (p) => http.get("/admin/pages", { headers: { "X-Admin-Passcode": p } }).then((r) => r.data),
  adminCreatePage: (p, payload) =>
    http.post("/admin/pages", payload, { headers: { "X-Admin-Passcode": p } }).then((r) => r.data),
  adminUpdatePage: (p, id, payload) =>
    http.put(`/admin/pages/${id}`, payload, { headers: { "X-Admin-Passcode": p } }).then((r) => r.data),
  adminDeletePage: (p, id) =>
    http.delete(`/admin/pages/${id}`, { headers: { "X-Admin-Passcode": p } }).then((r) => r.data),
  // Listings (public)
  listings: (params = {}) => http.get("/listings", { params }).then((r) => r.data),
  listing: (id) => http.get(`/listings/${id}`).then((r) => r.data),
  recruitment: (formData) =>
    http
      .post("/requests/recruitment", formData, { headers: { "Content-Type": "multipart/form-data" } })
      .then((r) => r.data),
  // Admin
  adminLogin: (passcode) => http.post("/admin/login", { passcode }).then((r) => r.data),
  adminStats: (passcode) => http.get("/admin/stats", { headers: { "X-Admin-Passcode": passcode } }).then((r) => r.data),
  adminRequests: (passcode, params = {}) =>
    http.get("/admin/requests", { headers: { "X-Admin-Passcode": passcode }, params }).then((r) => r.data),
  adminRequest: (passcode, id) =>
    http.get(`/admin/requests/${id}`, { headers: { "X-Admin-Passcode": passcode } }).then((r) => r.data),
  adminUpdate: (passcode, id, status) =>
    http.patch(`/admin/requests/${id}`, { status }, { headers: { "X-Admin-Passcode": passcode } }).then((r) => r.data),
  // Admin listings
  adminListings: (passcode) => http.get("/admin/listings", { headers: { "X-Admin-Passcode": passcode } }).then((r) => r.data),
  adminCreateListing: (passcode, payload) =>
    http.post("/admin/listings", payload, { headers: { "X-Admin-Passcode": passcode } }).then((r) => r.data),
  adminUpdateListing: (passcode, id, payload) =>
    http.put(`/admin/listings/${id}`, payload, { headers: { "X-Admin-Passcode": passcode } }).then((r) => r.data),
  adminDeleteListing: (passcode, id) =>
    http.delete(`/admin/listings/${id}`, { headers: { "X-Admin-Passcode": passcode } }).then((r) => r.data),
};

export default api;
